var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFactCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.5924 17.0885C3.17142 17.0885 2.8151 16.9427 2.52344 16.651C2.23177 16.3594 2.08594 16.0031 2.08594 15.5821V4.42833C2.08594 4.00736 2.23177 3.65104 2.52344 3.35938C2.8151 3.06771 3.17142 2.92188 3.5924 2.92188H16.4128C16.8338 2.92188 17.1901 3.06771 17.4818 3.35938C17.7734 3.65104 17.9193 4.00736 17.9193 4.42833V15.5821C17.9193 16.0031 17.7734 16.3594 17.4818 16.651C17.1901 16.9427 16.8338 17.0885 16.4128 17.0885H3.5924ZM3.5924 15.8385H16.4128C16.477 15.8385 16.5357 15.8118 16.5891 15.7583C16.6425 15.705 16.6693 15.6463 16.6693 15.5821V4.42833C16.6693 4.36417 16.6425 4.30542 16.5891 4.25208C16.5357 4.19861 16.477 4.17188 16.4128 4.17188H3.5924C3.52823 4.17188 3.46948 4.19861 3.41615 4.25208C3.36267 4.30542 3.33594 4.36417 3.33594 4.42833V15.5821C3.33594 15.6463 3.36267 15.705 3.41615 15.7583C3.46948 15.8118 3.52823 15.8385 3.5924 15.8385ZM4.3776 13.9635H8.1276V12.7135H4.3776V13.9635ZM12.1276 12.2087L15.9561 8.38021L15.0651 7.48917L12.1276 10.4475L10.9401 9.26L10.0699 10.151L12.1276 12.2087ZM4.3776 10.6302H8.1276V9.38021H4.3776V10.6302ZM4.3776 7.29688H8.1276V6.04688H4.3776V7.29688Z",
    fill: "#189FAA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFactCheck);
export default __webpack_public_path__ + "static/media/fact_check.9a95ac78309e7bf4a5c9b5a53567dbbb.svg";
export { ForwardRef as ReactComponent };